import React from "react";
import PropTypes from "prop-types";
import classcat from "classcat";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import moment from "moment";
import { translateEmployeeProperties } from "../../../../infrastructure/translate/translateEmployeeProperties";
import { translate as t } from "../../../../infrastructure/translate/localization";
import CheckBox from "../../../../app/components/commons/checkBox/CheckBox";
import ButtonAction from "../../../../app/components/commons/buttonAction/ButtonAction";

const showAllMsg = (msgs) => {
  let allString = "";
  msgs.forEach((msg) => {
    allString += ` ${translateEmployeeProperties("errors", msg)}. `;
  });

  return allString;
};

const TableEmployeeSummary = ({
  employeesList,
  employeesSelected,
  selectEmployee,
  editEmployee,
  deleteEmployee,
}) => {
  return (
    <table>
      <thead>
        <tr>
          <th className="row-select" aria-label="empty-header" />
          <th>{t("common-messages.internal-id")}</th>
          <th>{t("common-messages.name")}</th>
          <th>{t("common-messages.surnames")}</th>
          <th>{t("common-messages.legal-id")}</th>
          <th>{t("common-messages.email")}</th>
          <th>{t("v2.common.birth-date")}</th>
          <th>{t("common-messages.cost-center")}</th>
          <th>{t("common-messages.subsidiary")}</th>
          <th aria-label="empty-header" />
          <th aria-label="empty-header" />
        </tr>
      </thead>
      <tbody>
        {employeesList.map((e) => {
          const employeeErrors = e.errors && e.errors.length !== 0;
          const employeeWarnings = e.warnings && e.warnings.length !== 0;
          const employeeIsSelected = employeesSelected.some(
            (id) => id === e.employeeId
          );
          return (
            <tr
              key={e.employeeId}
              className={classcat([
                "container",
                { active: employeeIsSelected },
              ])}
            >
              <tr
                className={classcat([
                  { "no-border": employeeErrors || employeeWarnings },
                ])}
              >
                <td className="row-select">
                  <CheckBox
                    active={employeeIsSelected}
                    handlerClick={() => selectEmployee(e.employeeId)}
                  />
                </td>
                <td>{e.newObject.internalId || "-"}</td>
                <td>{e.newObject.name}</td>
                <td>{e.newObject.surname}</td>
                <td>{e.newObject.legalId}</td>
                <td>{e.newObject.email}</td>
                <td>
                  {e.newObject.birthDate &&
                    moment(e.newObject.birthDate).format("DD/MM/YYYY")}
                </td>
                <td>{e.newObject.costCenter}</td>
                <td>{e.newObject.payrollCompany}</td>
                <td className="min-content extra-content">
                  <ButtonAction
                    dataTip={t("actions.edit")}
                    icon="pen"
                    typeButton="icon-only"
                    handlerClick={() => editEmployee(e.newObject)}
                  />
                </td>
                <td className="min-content extra-content">
                  <ButtonAction
                    dataTip={t("actions.delete")}
                    icon="trash"
                    typeButton="icon-only"
                    handlerClick={() => deleteEmployee(e.employeeId)}
                  />
                </td>
              </tr>
              {(employeeErrors || employeeWarnings) && (
                <tr
                  className={classcat([
                    "message",
                    {
                      warning: employeeWarnings,
                      error: employeeErrors,
                    },
                  ])}
                >
                  <td>
                    <FontAwesomeIcon icon="exclamation-circle" />
                  </td>
                  <td colSpan="8">
                    {employeeErrors && <span>{showAllMsg(e.errors)}</span>}
                    {employeeWarnings && <span>{showAllMsg(e.warnings)}</span>}
                  </td>
                </tr>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

TableEmployeeSummary.propTypes = {
  employeesList: PropTypes.array.isRequired,
  employeesSelected: PropTypes.array.isRequired,
  selectEmployee: PropTypes.func.isRequired,
  editEmployee: PropTypes.func.isRequired,
  deleteEmployee: PropTypes.func.isRequired,
};

export default TableEmployeeSummary;
